import { Injectable } from '@angular/core';
import {SETTINGS} from "../config/common.settings";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class RoomTypesService {

  constructor(private http: HttpClient) { }

  getAllRoomTypes(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/room-types/get-paged`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response[0]);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getAllActiveRoomTypes(hotelId?: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/room-types/get-all`, {
          params: hotelId ? { hotel: hotelId } : {},
        })
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  getRoomTypeByID(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/room-types/get/${id}`).subscribe({
        next: (response: any) => {
          resolve(response);
        },
        error: (error: any) => {
          reject(error);
        },
      });
    });
  }

  createRoomType(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/room-types/create`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  updateRoomType(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/room-types/update`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  search(googleID: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/room-types/search`, {
          params: {googleID },
        })
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }
}
